/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function SortUp({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M4.924 1.576a.6.6 0 0 0-.848 0l-3 3a.6.6 0 0 0 .848.848L3.9 3.45V10a.6.6 0 1 0 1.2 0V3.449l1.976 1.975a.6.6 0 0 0 .848-.848zM11 3.6a.6.6 0 0 1 0-1.2h3.5a.6.6 0 1 1 0 1.2zM3 13.6a.6.6 0 1 1 0-1.2h11.5a.6.6 0 1 1 0 1.2zM8.4 8a.6.6 0 0 0 .6.6h5.5a.6.6 0 1 0 0-1.2H9a.6.6 0 0 0-.6.6" /></svg>;
}
;